import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { SignInFormComponent } from './components/sign-in-form/sign-in-form.component';
import { Routes, RouterModule } from '@angular/router';
import { SignInMainComponent } from './components/sign-in-main/sign-in-main.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SignOutComponent } from './components/sign-out/sign-out.component';
import { ActivateAccountComponent } from './components/activate-account/activate-account.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetConfirmComponent } from './components/reset-confirm/reset-confirm.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { PasswordStrengthMeterModule } from 'angular-password-strength-meter';

const routes: Routes = [
  { path: "signin", component: SignInMainComponent },
  { path: "signout", component: SignOutComponent },
  { path: "activate-account", component: ActivateAccountComponent },
  { path: "forgot-password", component: ForgotPasswordComponent},
  {path:"reset-confirm",component : ResetConfirmComponent},
  {path:"reset-password",component:ResetPasswordComponent}
];

@NgModule({
  declarations: [SignInMainComponent, SignInFormComponent, SignOutComponent, ActivateAccountComponent,ForgotPasswordComponent, ResetConfirmComponent, ResetPasswordComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    PasswordStrengthMeterModule
  ]
})
export class LoginModule { }
